module.exports = __webpack_public_path__ + "e3267f0aa858754e9f68c4e4dfecaac0.MP3";